//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import showroomSettingsPassthroughTemplate from '@legacy-components/common/universal-image-actions/showroom-settings-passthrough.html';

import _ from "js/underscore-mixins";

(function() {
  const uia = angular.module('uia');
  uia.component('showroomSettingsPassthrough', {
    bindings: {
      showDesktopExperience: '<',
      passthroughUrl: '<',
      onPassthroughChanged: '<',
    },
    template: showroomSettingsPassthroughTemplate,
    controller: [
      'ShowroomApiService',
      'ShowroomService',
      'TrackingService',
      function(
                ShowroomApiService,
                ShowroomService,
                TrackingService,
            ) {
        this.VALID_URL_REGEX = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/i;

        this.customPassthroughUrl = '';
        this.passthroughCollapsed = true;
        this.trackingCategory = ShowroomService.getTrackingCategory();

        const queryWithHttp = (query) => {
          if (query && !query.match(/^http(s)?:\/\//)) {
            query = `http://${query}`;
          }
          return query;
        };

        this.togglePassthroughCollapsed = () => {
          this.passthroughCollapsed = !this.passthroughCollapsed;
          TrackingService.recordEvent(
                        this.trackingCategory,
                        this.trackingAction,
                        this.trackingLabels.toggleDesktopSettings(this.passthroughCollapsed),
                    );
        };

        this.updatePassthroughSelection = (showDesktopExperience) => {
          this.onPassthroughChanged(showDesktopExperience, queryWithHttp(this.passthroughUrl));

          TrackingService.recordEvent(
                        this.trackingCategory,
                        this.trackingAction,
                        this.trackingLabels.toggleUseDesktop(showDesktopExperience),
                    );
        };

        this.updatePassthroughUrl = _.debounce(() => {
          this.onPassthroughChanged(this.showDesktopExperience, queryWithHttp(this.customPassthroughUrl));
        }, 200);

        this.$onInit = () => {
          this.customPassthroughUrl = angular.copy(this.passthroughUrl);

          this.trackingCategory = ShowroomService.getTrackingCategory();
          this.trackingAction = ShowroomService.getTrackingAction();
          this.trackingLabels = {
            toggleUseDesktop: (showDesktop) => { return (showDesktop) ? 'SelectDesktopExperience' : 'SelectPassthroughExperience'; },
            toggleDesktopSettings: (collapsed) => { return (collapsed) ? 'CollapseDesktopSettings' : 'OpenDesktopSettings'; },
          };
        };
      },
    ],
  });
})();
